/*
 Copyright (c), CKSource Holding sp. z o.o. All rights reserved.
 */

import Message, { IMessage } from './../../message';
import { IDescriptorBody } from '../../descriptor';

export interface IRemoveCommentThreadMessage extends IMessage {
	commentThreadId: string;
	documentId: string;
}

export default class RemoveCommentThreadMessage extends Message {
	public static readonly TYPE: string = '97';

	public static readonly READABLE_TYPE_NAME: string = 'removeCommentThread';

	public static readonly DESCRIPTOR_NAME: string = 'CommentsV2RemoveCommentThreadMessage';

	public static readonly DESCRIPTOR: IDescriptorBody = {
		fields: {
			commentThreadId: {
				type: 'string',
				id: 1
			},
			documentId: {
				type: 'string',
				id: 2
			}
		}
	};

	public constructor(
		public readonly documentId: string,
		public readonly commentThreadId: string
	) {
		super();
	}

	public toJSON(): IRemoveCommentThreadMessage {
		return {
			documentId: this.documentId,
			commentThreadId: this.commentThreadId
		};
	}

	public static fromJSON( object: IRemoveCommentThreadMessage ): RemoveCommentThreadMessage {
		return new RemoveCommentThreadMessage( object.documentId, object.commentThreadId );
	}
}
